(($, Cookies) => {
    const $alertbar = $('#alertbar');
    const storageHandle = (!$alertbar.attr('data-handle')) ? 'alertbar-' : $alertbar.attr('data-handle');
    const storageExpire = (!$alertbar.attr('data-expire') || $alertbar.attr('data-expire') == 'session') ? 'session' : Number($alertbar.attr('data-expire'));

    window.addEventListener('load', init);

    function init() {
        if ($alertbar.length === 0) {
            return null;
        }

        if (Cookies.get(storageHandle) || sessionStorage.getItem(storageHandle)) {
            $alertbar.remove();
            return null;
        }

        bind();

        $alertbar.addClass('initialized');
    }

    function bind() {
        $alertbar.on('closed.bs.alert', onClosedBSAlert);
    }

    function onClosedBSAlert(event) {
        if (!event instanceof Event) {
            return null;
        }
        if (storageExpire === 'session') {
            sessionStorage.setItem(storageHandle, true);
            return null;
        }

        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'close_alert_bar' }}));
        
        Cookies.set(storageHandle, true, { expires: storageExpire, path: '/', secure: true });
    }

})(jQuery, Cookies);